import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { ComponentRegistry } from 'core/registry';
import Button from 'components/Button';
import Spinner from 'components/Spinner';
import { Modal } from 'apps/modals/views/modal';
import { FormWrapperDiv } from 'libs/forms/styles';
import { FormDivider } from 'apps/signIn/styles';
import { SubscriptionCheckout } from 'apps/payment/subscription/checkout';
import { PaymentMethodsAppManager } from 'apps/payment/method/appManager';

import { ModalTitle, Center } from 'legacyComponents/styled/lib';
import { StripeWrapper, StripeCardForm } from 'apps/payment/method/newCardForm';

@withNamespaces()
@observer
export class ConfirmSubscription extends Modal {
  constructor(props) {
    super(props);
    const { appManager } = props;
    this.paymentMethodsManager = new PaymentMethodsAppManager(this, {
      spaceSlug: appManager.spaceSlug,
    });
  }

  updatePreview = () => {
    const { appManager } = this.props;
    const { paymentSpacePreview } = appManager;
    if (paymentSpacePreview) {
      appManager.NewPreviewExtraSeatsQuery(paymentSpacePreview.extraSeats || 0);
    } else {
      appManager.NewSubscriptionQuery({ preview: true });
    }
  };

  render() {
    const {
      appManager,
      confirmAction,
      title = 'Activating Subscription',
    } = this.props;
    const { paymentSpacePreview, paymentSpace } = appManager;
    const { paymentSpace: paymentMethodsSpace } = this.paymentMethodsManager;

    const preview = paymentSpacePreview && paymentSpacePreview.preview;

    if (
      !(paymentMethodsSpace && paymentSpace && paymentSpacePreview && preview)
    ) {
      return (
        <>
          <ModalTitle>
            <Trans>{title}</Trans>
          </ModalTitle>
          <FormDivider />
          <Spinner margin='30px auto 10px' />
        </>
      );
    }

    const confirmActionButton = (paymentMethodsSpace.hasValidPaymentMethod ||
      paymentSpacePreview?.preview?.finalAmount === 0) && (
      <Center>
        {paymentSpacePreview.subscribing ? (
          <Button text={<Trans>Subscribing...</Trans>} loading />
        ) : (
          <Button text={<Trans>Subscribe now</Trans>} onClick={confirmAction} />
        )}
      </Center>
    );

    const newPaymentMethodForm = !paymentMethodsSpace.hasValidPaymentMethod &&
      paymentSpacePreview?.preview?.finalAmount !== 0 && (
        <StripeWrapper>
          <StripeCardForm
            paymentMethodsManager={this.paymentMethodsManager}
            successAction={this.updatePreview}
          />
        </StripeWrapper>
      );

    return (
      <>
        <ModalTitle>
          <Trans>{title}</Trans>
        </ModalTitle>
        <FormDivider />
        <FormWrapperDiv posting={paymentSpacePreview.subscribing}>
          <SubscriptionCheckout
            paymentSpacePreview={paymentSpacePreview}
            allowAddSeats={!paymentSpace.subscription}
            coupon={paymentSpace.coupon}
            noPadding={false}
            actionable={paymentMethodsSpace.hasValidPaymentMethod}
          >
            {confirmActionButton}
          </SubscriptionCheckout>
        </FormWrapperDiv>
        {newPaymentMethodForm}
      </>
    );
  }
}

ConfirmSubscription.propTypes = {
  appManager: PropTypes.object,
  confirmAction: PropTypes.func,
  title: PropTypes.string,
};

ComponentRegistry.add('modals.ConfirmSubscription', ConfirmSubscription);
